import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { PaginationComponent, ResponsiveService } from '@frk/eds-components';
import { FundPerformanceMonthlyTotalReturnsStateData } from '@products/types';
import { EDSPaginationPageChangedEvent } from '@types';
import { Observable } from 'rxjs';

@Component({
  selector: 'ft-fund-performance-monthly-total-returns-table',
  templateUrl: './fund-performance-monthly-total-returns-table.component.html',
  styleUrls: ['./fund-performance-monthly-total-returns-table.component.scss'],
})
export class FundPerformanceMonthlyTotalReturnsTableComponent
  implements OnInit, OnChanges {
  @Input() tableData: FundPerformanceMonthlyTotalReturnsStateData;
  @Input() shareClass: string;
  @Input() monthlyTotalReturnsTableTotalPages: number;
  @Output() selectedPage = new EventEmitter<number>();
  public isHandheld$: Observable<boolean>;

  // pagination helpers
  public totalPages: number;
  @ViewChild(PaginationComponent, { static: false })
  paginationComponent: PaginationComponent;

  constructor(protected responsiveService: ResponsiveService) {}

  ngOnInit(): void {
    this.isHandheld$ = this.responsiveService.isHandheld$();
    if (this.monthlyTotalReturnsTableTotalPages) {
      this.totalPages = this.monthlyTotalReturnsTableTotalPages;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.monthlyTotalReturnsTableTotalPages &&
      !changes.monthlyTotalReturnsTableTotalPages.firstChange
    ) {
      this.totalPages = changes.monthlyTotalReturnsTableTotalPages.currentValue;
      this.paginationComponent?.updatePagination(this.totalPages); // Perform changes on pagination component.
    }
  }

  /**
   * Trigger page change with the page number selected.
   * @param event page changed event generated
   */
  public onPageChanged(event: EDSPaginationPageChangedEvent): void {
    // TODO : add analytics
    if (event.action !== 'load') {
      this.selectedPage.next(event.page);
    }
  }
}
